import { render, staticRenderFns } from "./currentOrders.vue?vue&type=template&id=3c0c01ca&"
import script from "./currentOrders.vue?vue&type=script&lang=js&"
export * from "./currentOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports